export { ExpandableText } from './ExpandableText';
export type { ExpandableTextProps } from './ExpandableText.types';
